import { useEffect, useState } from "react";
import { LiaSearchPlusSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import {
  ToolingTypeEntryAPI,
  rawMaterials,
  supplierDieAPI,
  Unit,
  ToolingTypeAPI,
  dieStatusAPI,
} from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import Model from "../../common/Model";
import FormFields from "../../common/FormFields";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import EntityAddModal from "../../common/EntityAddModal";
import Button from "../../common/Button";
import ToolingType from "./ToolingType";

const ToolingEntry = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    toolingId: 0,
    toolingDate: today,
    toolingTypeId: "",
    od_Value: "",
    id_Value: "",
    thickness: "",
    hardness: "",
    supplier_Id: "",
    status_Id: "",
    invoice_No: "",
    statusId: "",
    created_By: 1,
  });

  const [loading, setLoading] = useState(false);
  const [isToolingTypeEntryData, setIsToolingTypeEntryData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isSupplierData, setIsSupplierData] = useState([]);
  const [isToolingTypeData, setIsToolingTypeData] = useState([]);
  const [isStatusData, setIsStatusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const pageSize = 10;
  const [modalType, setModalType] = useState(null);

  const fetchToolingTypeEntryData = async () => {
    setLoading(true);
    try {
      const res = await ToolingTypeEntryAPI.getAllPagination(
        currentPage,
        pageSize
      );
      setIsToolingTypeEntryData(res.data || []);
      setFilteredData(res.data || []);
      setTotalRecords(res.totalCount || res.data?.length || 0);
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [toolingTypeRes, supplierRes, statusRes] = await Promise.all([
          ToolingTypeAPI.getAll(),
          supplierDieAPI.getAll(),
          dieStatusAPI.getAll(),
        ]);

        const supplierArray = Array.isArray(supplierRes?.data)
          ? supplierRes.data
          : [];
        setIsSupplierData(supplierArray);
        setIsToolingTypeData(
          Array.isArray(toolingTypeRes?.data) ? toolingTypeRes.data : []
        );
        setIsStatusData(statusRes);
      } catch (error) {
        notify("Error fetching dropdown data", "error");
      }
    };

    fetchDropdownData();
  }, []);

  useEffect(() => {
    fetchToolingTypeEntryData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isToolingTypeEntryData);
    } else {
      const filtered = isToolingTypeEntryData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isToolingTypeEntryData]);

  const handleInputChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleAdd = () => {
    setIsModelOpen(true);
    setIsEditing(false);
    setFormData({
      toolingId: 0,
      toolingDate: today,
      toolingTypeId: "",
      od_Value: "",
      id_Value: "",
      thickness: "",
      hardness: "",
      supplier_Id: "",
      invoice_No: "",
      statusId: "",
      created_By: 1,
    });
  };

  const handleEdit = async (id) => {
    try {
      const data = await ToolingTypeEntryAPI.getById(id);

      if (data.data) {
        setFormData({
          toolingId: data.data.toolingId,
          toolingDate: data.data.toolingDate?.split("T")[0],
          toolingTypeId: data.data.toolingTypeId,
          od_Value: data.data.od_Value,
          id_Value: data.data.id_Value,
          thickness: data.data.thickness,
          hardness: data.data.hardness,
          supplier_Id: data.data.supplier_Id,
          invoice_No: data.data.invoice_No,
          statusId: data.data.statusId,
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (error) {
      notify("Failed to fetch location details", "error");
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await ToolingTypeEntryAPI.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchToolingTypeEntryData();
    } catch (error) {
      notify("Failed to delete record", "error");
    }
    setIsDeleteModalOpen(false);
    setSelectedId(null);
  };

  const handleSubmit = async ({ resetOnly = false }) => {
    try {
      const payload = {
        ...formData,
        toolingId: parseInt(formData.toolingId),
        supplier_Id: parseInt(formData.supplier_Id),
        toolingTypeId: parseInt(formData.toolingTypeId),
        statusId: parseInt(formData.statusId),
      };
      await ToolingTypeEntryAPI.saveOrUpdate(payload);
      notify(
        isEditing ? "Updated successfully" : "Added successfully",
        "success"
      );
      fetchToolingTypeEntryData();
      setFormData("");
      setIsEditing(false);
      if (!resetOnly) {
        setIsModelOpen(false);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    }
  };

  const fields = [
    {
      name: "toolingDate",
      label: "Tooling Date",
      type: "date",
      required: true,
      errorMessage: "Date is required",
    },
    {
      name: "supplier_Id",
      label: "Supplier Name",
      type: "selectWithAdd",
      required: true,
      options: isSupplierData?.map((s) => ({
        value: s.supplier_Id,
        label: s.supplier_Name,
      })),
      onAddNew: () => setModalType("supplier"),
      errorMessage: "Supplier Name is required",
    },
    {
      name: "toolingTypeId",
      label: "Tooling Type Name",
      type: "selectWithAdd",
      required: true,
      options: isToolingTypeData?.map((s) => ({
        value: s.toolingTypeId,
        label: s.toolingType,
      })),
      onAddNew: () => setModalType("toolingType"),
      errorMessage: "Tooling Type Name is required",
    },
    {
      name: "od_Value",
      label: "OD Value",
      type: "text",
    },
    {
      name: "id_Value",
      label: "ID Value",
      type: "text",
    },
    {
      name: "thickness",
      label: "Thickness",
      required: true,
      errorMessage: "Thickness is required",
    },
    {
      name: "hardness",
      label: "Hardness",
      type: "number",
      required: true,
      errorMessage: "Hardness is required",
    },
    {
      name: "invoice_No",
      label: "Invoice No",
      type: "text",
    },
    {
      name: "statusId",
      label: "Status Name",
      type: "selectWithAdd",
      required: true,
      options: isStatusData?.map((s) => ({
        value: s.id,
        label: s.status_Name,
      })),
      onAddNew: () => setModalType("status"),
      errorMessage: "Status Name is required",
    },
  ];

  const optionMap = {
    supplier: {
      setter: setIsSupplierData,
      fetcher: supplierDieAPI.getAll,
      mapFn: (data) =>
        data?.map((c) => ({
          value: c.supplier_Id,
          label: c.supplier_Name,
        })),
      setField: "supplier_Id",
    },
    toolingType: {
      setter: setIsToolingTypeData,
      fetcher: ToolingType.getAll,
      mapFn: (data) =>
        data?.map((s) => ({
          value: s.toolingTypeId,
          label: s.toolingType,
        })),
      setField: "toolingTypeId",
    },
    status: {
      setter: setIsStatusData,
      fetcher: dieStatusAPI.getAll,
      mapFn: (data) =>
        data?.map((s) => ({
          value: s.id,
          label: s.status_Name,
        })),
      setField: "id",
    },
  };

  const handleEntityAddSuccess = async (type, newOption) => {
    const config = optionMap[type];
    if (!config) return;

    try {
      const response = await config.fetcher();
      const items = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
        ? response.data
        : [];

      config.setter(items);

      setFormData((prev) => ({
        ...prev,
        [config.setField]: newOption?.value || "",
      }));
      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };

  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    try {
      return new Date(isoString).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (e) {
      console.error("Error formatting date:", e);
      return "Invalid Date";
    }
  };

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5  mt-10 ">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              icon={LiaSearchPlusSolid}
              iconSize="w-5 h-5"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            ></Button>
            {searchQuery && (
              <Button
                icon={MdClose}
                onClick={() => setSearchQuery("")}
                iconSize="w-5 h-5"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              ></Button>
            )}
          </div>
          <Button
            text="Add Tooling Type Entry"
            className="bg-orange text-black font-semibold text-md rounded-md p-2"
            icon={HiOutlinePlus}
            iconColor="text-black"
            iconSpacing="pr-2"
            padding="p-2"
            onClick={handleAdd}
          />
        </div>

        {loading ? (
          <Loader />
        ) : (
          <Table
            columns={[
              {
                key: "toolingDate",
                label: "Tooling Date",
                render: (value) => formatDate(value),
              },
              { key: "toolingType", label: "Tooling Type Name" },
              { key: "od_Value", label: "Od Value" },
              { key: "id_Value", label: "Id Value" },
              { key: "thickness", label: "Thickness" },
              { key: "hardness", label: "Hardness" },
              { key: "invoice_No", label: "Invoice No" },
              { key: "supplier_Name", label: "Supplier Name" },
              { key: "status_Name", label: "Status Name" },
            ]}
            data={filteredData}
            onEdit={(row) => handleEdit(row.toolingId)}
            onDelete={(row) => handleDelete(row.toolingId)}
          />
        )}

        <div className="flex justify-center items-center mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize)}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>

      <Model
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        name={isEditing ? "Edit Tooling Type Entry" : "Add Tooling Type Entry"}
      >
        <FormFields
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: false });
          }}
          onSubmitAndAddNew={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: true });
          }}
          setIsModelOpen={setIsModelOpen}
          formData={formData}
          handleInputChange={handleInputChange}
          fields={fields}
          isEditing={isEditing}
          onClear={() => setIsModelOpen(false)}
        />
      </Model>
      <Model
        isOpen={!!modalType}
        onClose={() => setModalType(null)}
        name={`Add ${modalType}`}
      >
        <EntityAddModal
          type={modalType}
          onClose={(newOption) => {
            setModalType(null);
            handleEntityAddSuccess(modalType, newOption);
          }}
        />
      </Model>
      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </>
  );
};

export default ToolingEntry;
